

const Header = (props)=>{
    
    return (
        

        <header className="container-fluid d-flex justify-content-end  " >
            <div className="d-flex align-item-center">
                <div >
                    
                    <span className="d-block m-0 p-0 text-white ">{props.name}</span>
                    <span className="d-block m-0 p-0 text-white ">{props.email}</span>
                    
                </div>
             
             <span className="mdi mdi-chevron-down text-white"> </span>
            </div>
        </header>
    )
}


export default Header